export const HORSE_SEXES = {
  f: "Filly",
  c: "Colt",
  m: "Mare",
  h: "Horse",
  g: "Gelding",
  r: "Ridgling"
};

export const TODAYS_RIDES_STRING = "Today's rides";
export const TODAYS_ENTRIES_STRING = "Today's entries";



// WEBPACK FOOTER //
// ./modules/HorseRacing/consts.js